import { environment } from '../../environments'
import { authenticatedFetch } from '../auth'
import type { TypedResponse } from '../auth/authenticatedFetch'
import type { ChannelInfo, NotificationChannelInfo } from '../notification-channel/models'
import { DEFAULT_CHANNEL_LIFETIME } from './model'

/**
 * Create channel info make sure you obtain the websocket url to connect
 *
 * https://developer-internal.goto.com/apis/notification-channel/v1#operation/createChannel
 *
 * @param externalUserKey
 * @returns ChannelInfo
 */
export const getChannelInfo = async (externalUserKey: string) =>
  await authenticatedFetch<NotificationChannelInfo>(
    `${environment().notificationChannelUrl}/channels/${externalUserKey}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        channelLifetime: DEFAULT_CHANNEL_LIFETIME,
      }),
    },
  ).then(response => response.json())
/**
 * Update channel info make sure you obtain the websocket url to connect
 *
 * https://developer-internal.goto.com/apis/notification-channel/v1#operation/refreshChannelLifetime
 *
 * @param externalUserKey
 * @param channelId
 * @returns ChannelInfo
 */
export const updateChannelInfoLifeTime = async (externalUserKey: string, channelId: string) =>
  await authenticatedFetch<ChannelInfo>(
    `${environment().notificationChannelUrl}/channels/${externalUserKey}/${channelId}/channel-lifetime`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  ).then(response => response.json())

/**
 * In order to dispose the notification channel
 *
 * https://developer-internal.goto.com/apis/notification-channel/v1#operation/deleteChannel
 *
 * @param externalUserKey
 * @returns Promise<TypedResponse<void>>
 */
export const destroyChannelInfo = async (externalUserKey: string, channelId: string): Promise<TypedResponse<void>> =>
  await authenticatedFetch<void>(`${environment().notificationChannelUrl}/channels/${externalUserKey}/${channelId}`, {
    method: 'DELETE',
  })
